export default __webpack_public_path__ + "static/media/flag.d9b1a692.jpg";